import BaseModel from '../core/BaseModel'

export default class OrganizationModel extends BaseModel {
    constructor() {
        super({
                name: "report_violation",
                tableName: 'core_report_violation',
                display_key: 'name'
            },
            {
                id: {
                    name: 'id',
                    type: "String",
                    label: 'ID',
                    primaryKey: true,
                    display: false
                },
                created_at: {
                    name: 'created_at',
                    type: "CustomDateTime",
                    label: 'Thời gian báo cáo',
                    class: 'top-datepicker',
                    sortable: true,
                    width: 15,
                    filter: {type: 'DateRange', match: 'custom'}
                },
                serial_number: {
                    name: 'serial_number',
                    type: "String",
                    label: 'Serial number',
                    sortable: true,
                    width: 10,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var text = (data.product_info !== undefined && data.product_info !== null) ? JSON.parse(data.product_info).serial_number  :  '';
                        data.serial_number = text;
                    }
                },
                pro_model_code: {
                    name: 'pro_model_code',
                    type: "String",
                    label: 'Model sản phẩm',
                    sortable: true,
                    width: 10,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var text = '';
                        if (data.product_info !== undefined && data.product_info !== null){
                            var product_info = JSON.parse(data.product_info);
                            if (product_info.product !== undefined && product_info.product !== null){
                                text = product_info.product.model_code;
                            }
                        }
                        data.pro_model_code = text;
                    }
                },
                pro_name: {
                    name: 'pro_name',
                    type: "String",
                    label: 'Tên sản phẩm',
                    sortable: true,
                    width: 10,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var text = '';
                        if (data.product_info !== undefined && data.product_info !== null){
                            var product_info = JSON.parse(data.product_info);
                            if (product_info.product !== undefined && product_info.product !== null){
                                text = product_info.product.name;
                            }
                        }
                        data.pro_name = text;
                    }
                },
                /*product_serial_number: {
                    refs: 'product_serial_number { id warranty_status serial_number product { model_code name categories { name id } }  product_serial_number_info { warranty_status status } }',
                    display: false
                },*/
                type_vio_name: {
                    name: 'type_vio_name',
                    type: "String",
                    label: 'Loại sự cố',
                    sortable: true,
                    width: 10,
                    filter: { type: 'input',  match: 'custom'},
                    computed: (data) => {
                        var text = (data.type_violation !== undefined && data.type_violation !== null) ? data.type_violation.name  :  '';
                        data.type_vio_name = text;
                    }
                },
                processStatus: {
                    name: 'processStatus', label: 'Trạng thái xử lý', type: "Selection",  dataType: 'Label',  class: 'center', width: 15,
                    options: [{ value: 2, label: 'Báo cáo sai'},{ value: 1, label: 'Hoàn thành'}, { value: 0, label: 'Chờ xử lý'}],
                    filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' },
                    sortable: true,
                    computed: (data) => {
                        data.processStatus = data.status;//(data.status == 0 && data.process_status == 0 ) ? 0 : ((data.status == 0 && data.process_status == 1) || data.status == 1) ? 1 : -1;
                    }
                },
                processStatusSortTmp: {
                    name: 'processStatusSortTmp',
                    type: "String",
                    label: 'Serial number',
                    sortable: true,
                    width: 10,
                    display: false,
                    filter: { type: 'input',  match: 'contains'},
                    computed: (data) => {
                        //đổi lại thứ tự status để sort
                        if (data.id == 38){
                            console.log("data.statusdata.status:",data.status)
                        }
                        switch(data.status) {
                            case 0:
                                data.processStatusSortTmp = 1;
                                break;
                            case 1:
                                data.processStatusSortTmp = 3;
                                break;
                            case 2:
                                data.processStatusSortTmp = 2;
                                break;
                            default:
                            // code block
                        }
                    }
                },
                status: {
                    name: 'status',
                    type: "Int",
                    label: '---',
                    class: 'top-datepicker',
                    sortable: true,
                    display: false
                },
                type_violation: {
                    refs: 'note type_violation { name }',
                    display: false
                },
                users: {
                    refs: 'users { user_type full_name phone_number user_role { roles { name } } organization_account { organization { name organization_parent { name } } } }',
                    display: false
                },
                field_hide: {
                    refs: 'product_info modified_date processed_note modifier { full_name organization_account { organization { name organization_parent { name } } } }',
                    display: false
                },
            },)
    }

}